function useFindAttributeValueByName(attributes, name) {
  if (!attributes || !name) {
    return null;
  }
  const attribute = attributes.find(attribute => attribute.attribute_name === name);
  return attribute ? attribute.attribute_value : null;
}

export default useFindAttributeValueByName;
